// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3C1KY","title":"BackImages_title__1ZHBE","images":"BackImages_images__3VTqM"};